import { render, staticRenderFns } from "./updateCommonTypeDialog.vue?vue&type=template&id=5b997afa"
import script from "./updateCommonTypeDialog.vue?vue&type=script&lang=ts"
export * from "./updateCommonTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports